

function EvaluateButton({ onClick }) {
  return <button onClick={() => onClick()} className="btn btn-block btn-success">=</button>;
}

export default EvaluateButton;
